const GruposHome = () => import(/* webpackChunkName: "group-pabx-cadastros-grupocaptura" */ '../_views/GruposHome')
const CadastroGrupoCaptura = () =>
  import(/* webpackChunkName: "group-pabx-cadastros-grupocaptura" */ '../_views/CadastroGrupoCaptura')
const AtualizarGrupoCaptura = () =>
  import(/* webpackChunkName: "group-pabx-cadastros-grupocaptura" */ '../_views/AtualizarGrupoCaptura')

import { permissionsPabx } from '../../../../../../utils/permissionsPabx'

export default [
  {
    path: 'grupos',
    component: GruposHome,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Grupos',
  },
  {
    path: 'grupos/criar',
    component: CadastroGrupoCaptura,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'grupos/criar',
  },
  {
    path: 'grupos/atualizar/:_id',
    component: AtualizarGrupoCaptura,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'grupos/atualizar',
    props: true,
  },
]
